import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import  styles from "./VersionModalDelete.module.scss";
import i18n from "i18n";

const VersionModalDelete = ({ version, open, onClose, onDelete }) => {

  const handleDelete = () => {
    onDelete(version);
    onClose();
  };

  return (
    <Dialog className={styles["dialog_version"]} open={open} onClose={onClose}>
      <DialogTitle>{i18n.t("delete.version")}</DialogTitle>
      <DialogContent>
      <Typography>{i18n.t("confirm.delete.version", { version })}</Typography>

      </DialogContent>
      <DialogActions>
        <Button className={styles["btn_cancel"]} onClick={onClose}>
        {i18n.t("cancel")}
        </Button>
        <Button
          className={styles["btn_delete"]}
          onClick={handleDelete}
        >
          {i18n.t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionModalDelete;
